import { mapGetters } from 'vuex'

export const GlobalMixin = {
  computed: {
    ...mapGetters({
      messages: 'data/messages'
    })
  }
}



// WEBPACK FOOTER //
// ./mixins/GlobalMixin.js